import { useState, useEffect } from 'react'

const DEV_USER = {
  id: 123456789,
  first_name: 'Test',
  username: 'testuser',
}

const DEV_TELEGRAM = {
  initData: 'user=%7B%22id%22%3A123456789%2C%22first_name%22%3A%22Test%22%2C%22username%22%3A%22testuser%22%7D&auth_date=1699999999&hash=dev_hash',
  initDataUnsafe: { user: DEV_USER },
  ready: () => {},
  expand: () => {},
  close: () => {},
  colorScheme: 'light' as const,
  themeParams: {
    bg_color: '#ffffff',
    text_color: '#000000',
    hint_color: '#999999',
    link_color: '#3390ec',
    button_color: '#3390ec',
    button_text_color: '#ffffff',
    secondary_bg_color: '#f5f5f5',
  },
  MainButton: {
    setText: () => {},
    setParams: () => {},
    show: () => {},
    hide: () => {},
    onClick: () => {},
  },
  HapticFeedback: {
    impactOccurred: () => {},
    notificationOccurred: () => {},
    selectionChanged: () => {},
  },
  switchInlineQuery: (text: string) => { console.log('Share:', text); alert('分享成功！获得500金币'); },
  openLink: (url: string) => window.open(url, '_blank'),
  openTelegramLink: (url: string) => window.open(url, '_blank'),
  shareUrl: (url: string) => console.log('shareUrl:', url),
  showPopup: async () => 'ok',
  showConfirm: async () => true,
}

export function useTelegram() {
  const [tg, setTg] = useState<any>(null)
  const [user, setUser] = useState<any>(null)
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined' && window.Telegram?.WebApp) {
      const webApp = window.Telegram.WebApp
      setTg(webApp)
      setUser(webApp.initDataUnsafe?.user || null)
      setIsReady(true)
    } else if (import.meta.env.DEV) {
      // Development mode: auto-inject mock Telegram user
      setTg(DEV_TELEGRAM)
      setUser(DEV_USER)
      setIsReady(true)
    } else {
      setIsReady(true)
    }
  }, [])

  return { tg, user, isReady }
}
